import { Injectable, InjectionToken, inject } from '@angular/core';
import {
  HubConnection,
  HubConnectionBuilder,
  IHttpConnectionOptions,
} from '@microsoft/signalr';
import { BehaviorSubject, Observable, firstValueFrom, map } from 'rxjs';

import { AuthInternalService } from './auth-internal.service';
import { environment } from './environment';

export type SignalRMaintenanceEvent =
  | 'maintenanceUtlysningsbyggare'
  | 'maintenanceFormbuilder'
  | 'maintenanceOthers';
export const SIGNALR_MAINTENANCE_EVENT =
  new InjectionToken<SignalRMaintenanceEvent>('SIGNALR_MAINTENANCE_EVENT', {
    providedIn: 'root',
    factory: () => 'maintenanceOthers',
  });

@Injectable({ providedIn: 'root' })
export class SignalRInternalService {
  private connection!: HubConnection;

  private _maintenanceModeActivated$ = new BehaviorSubject<boolean>(false);
  public readonly maintenanceModeActivated$: Observable<boolean> =
    this._maintenanceModeActivated$.asObservable();

  private authService = inject(AuthInternalService);
  private env = inject(environment);
  private maintenanceEvent = inject(SIGNALR_MAINTENANCE_EVENT);

  init(scopes: string[], authority: string) {
    const options = {
      accessTokenFactory: async () => {
        return firstValueFrom(
          this.authService
            .getAccessToken(scopes, authority)
            .pipe(map((a) => a.accessToken)),
        );
      },
    } as IHttpConnectionOptions;

    this.connection = new HubConnectionBuilder()
      .withUrl(`${this.env.etjansterCommonUrl}/hub`, options)
      .withAutomaticReconnect()
      .build();

    this.setEventListeners();
    this.connection
      .start()
      .catch((err) => console.error('SignalR connection error:', err));
  }

  private setEventListeners() {
    this.connection.on(this.maintenanceEvent, () => {
      this._maintenanceModeActivated$.next(true);
    });
  }
}
